import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// --- Response Interfaces ---

export interface DemandImportResponse {
    readonly uuid: string;
    readonly fileName: string;
    readonly demandCode: string | null;
    readonly status: string;
    readonly createdAt: string;
    readonly updatedAt: string | null;
}

export interface DemandActiveCode {
    readonly code: string;
    readonly startDate: string;
    readonly endDate: string;
}

export interface DemandImportBranch {
    readonly uuid: string;
    readonly branchCode: string;
    readonly status: string;
    readonly message: string | null;
    readonly createdAt: string;
    readonly updatedAt: string | null;
}

export interface DemandImportProduct {
    readonly uuid: string;
    readonly productCode: string;
    readonly demandedAmount: number;
    readonly referenceDate: string;
}

export interface DemandImportError {
    readonly code: string;
    readonly message: string;
    readonly messageCustomer: string;
}

// --- Service ---

@Injectable({
    providedIn: 'root'
})
export class DemandImportService {
    readonly #http = inject(HttpClient);
    readonly #apiUrl = `${environment.apiUrl}/DemandImport`;

    getAll(): Observable<DemandImportResponse[]> {
        return this.#http.get<DemandImportResponse[]>(this.#apiUrl);
    }

    getActiveCodes(): Observable<DemandActiveCode[]> {
        return this.#http.get<DemandActiveCode[]>(`${this.#apiUrl}/ActiveCodes`);
    }

    getBranches(uuid: string): Observable<DemandImportBranch[]> {
        return this.#http.get<DemandImportBranch[]>(`${this.#apiUrl}/${uuid}/Branches`);
    }

    getProducts(uuid: string, branchUuid: string): Observable<DemandImportProduct[]> {
        return this.#http.get<DemandImportProduct[]>(
            `${this.#apiUrl}/${uuid}/Branches/${branchUuid}/Products`
        );
    }

    schedule(uuid: string, demandCode: string): Observable<void> {
        return this.#http.post<void>(`${this.#apiUrl}/${uuid}/Schedule`, { demandCode });
    }

    retryBranch(uuid: string, branchUuid: string): Observable<void> {
        return this.#http.patch<void>(
            `${this.#apiUrl}/${uuid}/Branches/${branchUuid}/Retry`,
            {}
        );
    }
}
